import * as yup from 'yup'

import {
  EVENT_FORM_CONTEXT_ERRATA_APPLIES,
  EVENT_FORM_CONTEXT_ERRATA_RECIPIENT_ATTENDEE_ID,
} from './formContext'

import {
  DR_NOTES_CHAR_LIMIT,
  DR_SPELLINGS_CHAR_LIMIT,
  DR_TIMESTAMPS_CHAR_LIMIT,
} from '@/components/Event/NewScript/constants'
import { attendeesFieldSchema } from '@/components/Event/NewScript/schemas/attendeeSchema'
import { canceledEventSchema } from '@/components/Event/NewScript/schemas/canceledEventSchema'
import { lowConfidenceWordSchema } from '@/components/Event/NewScript/schemas/lowConfidenceWordsSchema'
import { getMaxCharactersMessage } from '@/components/Event/NewScript/schemas/validation'

export const defaultReviewStepSchema = yup.object({
  timestamps: yup
    .string()
    .max(
      DR_TIMESTAMPS_CHAR_LIMIT,
      getMaxCharactersMessage(DR_TIMESTAMPS_CHAR_LIMIT),
    )
    .nullable()
    .default(null),
  spellings: yup
    .string()
    .max(
      DR_SPELLINGS_CHAR_LIMIT,
      getMaxCharactersMessage(DR_SPELLINGS_CHAR_LIMIT),
    )
    .nullable()
    .default(null),
  notes: yup
    .string()
    .max(DR_NOTES_CHAR_LIMIT, getMaxCharactersMessage(DR_NOTES_CHAR_LIMIT))
    .nullable()
    .default(null),
  // Closing requires an address for the chosen recipient, and this screen can
  // edit that attendee, so the same rule holds here: nothing can be sent to a
  // recipient with no address.
  attendees: attendeesFieldSchema.when(
    [
      `$${EVENT_FORM_CONTEXT_ERRATA_APPLIES}`,
      `$${EVENT_FORM_CONTEXT_ERRATA_RECIPIENT_ATTENDEE_ID}`,
    ],
    ([errataApplies, recipientAttendeeId], schema) => {
      if (!errataApplies || !recipientAttendeeId) {
        return schema
      }

      return schema.test('errata-recipient-email', (value, context) => {
        const recipient = value?.find(
          attendee => attendee.attendee_id === recipientAttendeeId,
        )

        if (!recipient || recipient.email) {
          return true
        }

        return context.createError({
          path: 'attendees.global.errataRecipient',
          type: 'custom',
          message: 'Email is required for the errata recipient',
        })
      })
    },
  ),
})

export const cancelledReviewStepSchema = yup
  .object({
    attendees: attendeesFieldSchema,
  })
  .concat(canceledEventSchema)

export const endStepSchema = yup.object({
  state: yup.string().required('State is required'),
  county: yup.string().required('County is required'),
  lowConfidenceWords: yup
    .array()
    .of(lowConfidenceWordSchema)
    .nullable()
    .default(null),
  events: yup.array().of(defaultReviewStepSchema).nullable().default(null),
})
